import { render } from "./Repositorio.vue?vue&type=template&id=528d6f23"
import script from "@/assets/js/repositorio.js?vue&type=script&lang=js"
export * from "@/assets/js/repositorio.js?vue&type=script&lang=js"

import "./Repositorio.vue?vue&type=style&index=0&id=528d6f23&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__